export default __webpack_public_path__ + "fc80d66b42d2f3278e3a25fe6f645ede.svg";